import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneBrandPayload } from '@app-store/slices/onbordingOrganizer/oneBrand'

interface TaskAction extends Action {
    payload: IOneBrandPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.onbordingOrganizer.oneBrand

function* getOneBrandTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/event/branding/${payload.brandId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneBrandSaga(): any {
    yield takeLatest<TaskAction>(onRequest, getOneBrandTask)
}

export default oneBrandSaga
